import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { ListItemDiv } from '@wix/da-ds/pkg/List/ListItem';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import { formatDollarsWithOptionalCents } from '../../../../../../utils/formatting';
import UserAvatar from '../../../../../../User/Avatar/UserAvatar';
import BasicUserLink from '../../../../../../User/_partials/BasicUserLink';
import { useViewOffersAction } from '../../hooks';
import s from './OfferList.scss';
const OFFERS_DISPLAY_MAX = 3;
const OfferList = ({ deviation, offers, className })=>{
    const { t } = useTranslation();
    const [handleShowMoreClick, showMoreBiData] = useViewOffersAction(deviation, {
        sectionname: 'side-rail'
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['offers']
    }, offers.slice(0, OFFERS_DISPLAY_MAX).map((offer, index)=>offer.from && /*#__PURE__*/ React.createElement(ListItemDiv, {
            key: index,
            className: s['offer'],
            compact: true,
            prefix: /*#__PURE__*/ React.createElement(UserAvatar, {
                user: offer.from,
                size: 24
            }),
            label: /*#__PURE__*/ React.createElement(BasicUserLink, {
                user: offer.from,
                className: s['user-name-link']
            }, offer.from.username),
            suffix: /*#__PURE__*/ React.createElement("span", {
                className: s['offer-price']
            }, formatDollarsWithOptionalCents(offer.dollarPrice))
        }))), offers.length > OFFERS_DISPLAY_MAX && /*#__PURE__*/ React.createElement(TextButton, {
        className: s['show-more-button'],
        size: "medium",
        variant: "main",
        onClick: handleShowMoreClick,
        biData: showMoreBiData
    }, t('sidebar.exclusives.offerList.cta.showAllOffers', {
        offersCount: offers.length
    })));
};
OfferList.displayName = 'OfferList';
export default OfferList;

//# sourceMappingURL=OfferList.js.map